export default function BlankLoadingPage() {
  // This loading page should never be seen in production because this loading state only
  // happens on the server. We don't want to import the Widget loading page or the DI loading page
  // as that will increase the bundle size for the main bundle.
  return null;
}
